// extracted by mini-css-extract-plugin
module.exports = {"primary":"#8dc63f"};